import { render, staticRenderFns } from "./OrderLand.vue?vue&type=template&id=79f155e6&scoped=true&"
import script from "./OrderLand.vue?vue&type=script&lang=js&"
export * from "./OrderLand.vue?vue&type=script&lang=js&"
import style0 from "./OrderLand.vue?vue&type=style&index=0&id=79f155e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f155e6",
  null
  
)

export default component.exports